let getters = {
  paymentOptions (state) {
    return state.paymentOptions
  },
  paymentMethods (state) {
    return state.paymentMethods
  },
  payableAmount (state) {
    return state.payableAmount
  },
  paymentRequest (state) {
    return state.paymentRequest
  },
  userPromotionV3 (state) {
    return state.userPromotionV3
  },
  categoriesDashboard (state) {
    return state.categoriesDashboard
  },
  merchants (state) {
    return state.merchants
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/eplNewDashboard/getters.js